/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CpaInfindCeasByCta model module.
 * @module model/CpaInfindCeasByCta
 * @version 2.8.0
 */
class CpaInfindCeasByCta {
    /**
     * Constructs a new <code>CpaInfindCeasByCta</code>.
     * @alias module:model/CpaInfindCeasByCta
     * @param headIndex {Number} 
     * @param tailIndex {Number} 
     * @param label {String} 
     * @param uri {String} 
     */
    constructor(headIndex, tailIndex, label, uri) { 
        
        CpaInfindCeasByCta.initialize(this, headIndex, tailIndex, label, uri);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, headIndex, tailIndex, label, uri) { 
        obj['headIndex'] = headIndex;
        obj['tailIndex'] = tailIndex;
        obj['label'] = label;
        obj['uri'] = uri;
    }

    /**
     * Constructs a <code>CpaInfindCeasByCta</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CpaInfindCeasByCta} obj Optional instance to populate.
     * @return {module:model/CpaInfindCeasByCta} The populated <code>CpaInfindCeasByCta</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CpaInfindCeasByCta();

            if (data.hasOwnProperty('headIndex')) {
                obj['headIndex'] = ApiClient.convertToType(data['headIndex'], 'Number');
            }
            if (data.hasOwnProperty('tailIndex')) {
                obj['tailIndex'] = ApiClient.convertToType(data['tailIndex'], 'Number');
            }
            if (data.hasOwnProperty('label')) {
                obj['label'] = ApiClient.convertToType(data['label'], 'String');
            }
            if (data.hasOwnProperty('uri')) {
                obj['uri'] = ApiClient.convertToType(data['uri'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} headIndex
 */
CpaInfindCeasByCta.prototype['headIndex'] = undefined;

/**
 * @member {Number} tailIndex
 */
CpaInfindCeasByCta.prototype['tailIndex'] = undefined;

/**
 * @member {String} label
 */
CpaInfindCeasByCta.prototype['label'] = undefined;

/**
 * @member {String} uri
 */
CpaInfindCeasByCta.prototype['uri'] = undefined;






export default CpaInfindCeasByCta;

